// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"d5755e69","41":"d294f583","61":"203b1a3f","623":"0b813cec","674":"5986ca1b","687":"37a020a2","751":"9287b2a1","978":"8fc5e6b6"}[chunkId] + ".chunk.js";
};